
import React, { useEffect, useRef, useState } from "react";
import TimeAttendance from "./AttendanceCalender.";
import AttendanceTable from "./AttendanceTable";
import { getUserInfoFromToken } from "../../utils/authUtils";


const Attendance = () => {
  // const userType = localStorage.getItem("user_type");
   const [userType, setUserType] = useState(null);
    const [userId, setUserId] = useState(null);
  const formikRef = useRef();
                useEffect(() => {
                const { userType, userId } = getUserInfoFromToken();
                setUserType(userType);
                setUserId(userId);
              }, []);

  if (userType === "Employee") {
    return <TimeAttendance/>;
  } else if (userType === "Employer" || userType === "Admin") {
    return <AttendanceTable/>;
  } else {
    return <div>User type not recognized. Please log in again.</div>;
  }
};

export default Attendance;
